<ng-helmet>
  <title>{{ 'talentSearchV2.pageTitle' | translate }}</title>
  <meta name="description" [content]="'talentSearchV2.pageDescription' | translate">
</ng-helmet>

<app-ts-v2-header/>

<div class="page-padding bg-[#061430] relative overflow-hidden">
  <!-- Background glow blobs -->
  <div class="absolute -top-[200px] -end-[100px] w-[600px] h-[600px] rounded-full bg-[#353CD8]/[0.35] blur-[120px] pointer-events-none"></div>
  <div class="absolute -bottom-[100px] -start-[80px] w-[400px] h-[400px] rounded-full bg-[#4CEA63]/[0.08] blur-[120px] pointer-events-none"></div>
  <app-ts-v2-hero-section/>
</div>

<div class="page-padding bg-[#F5F7FF] border-t border-b border-[rgba(6,20,48,0.09)]">
  <app-ts-v2-trusted-by-section/>
</div>

<div class="page-padding bg-white" id="pool">
  <app-ts-v2-talent-pool-section/>
</div>

<div class="page-padding bg-[#E9F1FF]">
  <app-ts-v2-stats-band-section/>
</div>

<div class="page-padding bg-[#0C2551]" id="how">
  <app-ts-v2-steps-section/>
</div>

<div class="page-padding bg-white flex flex-col py-14 md:py-[120px] gap-14 md:gap-[120px]">
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-x-10 lg:gap-x-[60px] gap-y-10 lg:gap-y-[120px] items-center">
    <app-ts-v2-exact-hire-section/>
    <app-ts-v2-ranking-section/>
  </div>
  <app-ts-v2-pipeline-section/>
</div>

<div class="page-padding bg-[#0C2551]">
  <app-ts-v2-pricing-section/>
</div>

<div class="page-padding bg-[#E9F1FF]" id="testimonials">
  <app-ts-v2-testimonials-section/>
</div>

<div class="page-padding bg-[#FAFAFA]" id="faq">
  <app-ts-v2-faq-section/>
</div>

<div class="page-padding py-10 md:py-20 bg-white">
  <app-ts-v2-cta-section/>
</div>

<main-footer/>
